import { render, staticRenderFns } from "./NotIncludeTax.vue?vue&type=template&id=13784701&scoped=true&"
import script from "./NotIncludeTax.vue?vue&type=script&lang=js&"
export * from "./NotIncludeTax.vue?vue&type=script&lang=js&"
import style0 from "./NotIncludeTax.vue?vue&type=style&index=0&id=13784701&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13784701",
  null
  
)

export default component.exports